<section id="solutions" aria-labelledby="solutions-heading" class="border-t border-cp-line">
  <div [class]="inner + ' ' + pad">
    <div class="grid grid-cols-1 gap-6 lg:grid-cols-2 lg:gap-12">
      <h2 id="solutions-heading" [class]="h2">Our Credit Solutions</h2>
      <p [class]="lead + ' max-w-[46ch] lg:pt-2'">
        Access diverse credit solutions designed to help you lead the conversation, guide financial outcomes, and protect long-term wealth strategies.
      </p>
    </div>

    <div class="mt-16 grid grid-cols-1 gap-10 border-t border-cp-line pt-10 lg:grid-cols-12 lg:gap-12">
      <!-- Mobile: horizontal scroll-snap row. Desktop: sticky list. -->
      <div class="lg:col-span-4">
        <div
          role="tablist"
          aria-label="Credit solutions"
          class="-mx-5 flex snap-x snap-mandatory gap-2 overflow-x-auto px-5 pb-2 sm:-mx-8 sm:px-8 lg:sticky lg:top-24 lg:mx-0 lg:flex-col lg:gap-0 lg:overflow-visible lg:px-0 lg:pb-0">
          @for (id of tabIds; track id) {
            <button
              type="button"
              role="tab"
              [id]="'solution-tab-' + id"
              [attr.aria-selected]="isActive(id)"
              aria-controls="solution-panel"
              [tabindex]="isActive(id) ? 0 : -1"
              (click)="setActiveSolution(id)"
              (keydown)="onTabKeydown($event, id)"
              [class]="'group flex shrink-0 snap-start items-center gap-3 whitespace-nowrap rounded-full px-4 py-2 text-left text-[15px] transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-cp-accent lg:whitespace-normal lg:rounded-none lg:border-l-2 lg:px-4 lg:py-2.5 ' +
                (isActive(id) ? 'bg-cp-fill text-cp-ink lg:border-cp-ink lg:bg-transparent' : 'text-cp-muted hover:text-cp-ink lg:border-cp-line')">
              {{ id === overviewId ? 'Overview' : titleFor(id) }}
            </button>
          }
        </div>
      </div>

      <div id="solution-panel" role="tabpanel" tabindex="0" [attr.aria-labelledby]="'solution-tab-' + activeSolutionId" class="rounded-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-8 focus-visible:outline-cp-accent lg:col-span-8">
        @if (activeSolutionId === overviewId) {
          <h3 class="text-[1.75rem] font-[510] leading-[1.15] tracking-[-0.022em] text-cp-ink">{{ overviewContent.title }}</h3>
          <div [class]="body + ' mt-5 max-w-[66ch] space-y-5 text-[16px]'">
            @for (paragraph of overviewContent.paragraphs; track $index) {
              <p>{{ paragraph }}</p>
            }
          </div>
          <div class="mt-8">
            <button type="button" (click)="onRequestTerms()" [class]="btnPrimary">Request Terms</button>
          </div>
        }

        @if (activeSolutionId !== overviewId && currentSolution; as solution) {
          <article>
            <h3 class="text-[1.75rem] font-[510] leading-[1.15] tracking-[-0.022em] text-cp-ink">{{ solution.title }}</h3>
            <p [class]="lead + ' mt-2'">{{ solution.shortDescription }}</p>

            <div [class]="body + ' mt-6 max-w-[66ch] text-[16px]'">
              <p>{{ solution.description[0] }}</p>
              @if (solution.description.length > 1) {
                <details class="group mt-4">
                  <summary class="inline-flex cursor-pointer list-none items-center gap-1 rounded-sm text-cp-ink hover:text-cp-muted focus-visible:outline focus-visible:outline-2 focus-visible:outline-cp-accent [&::-webkit-details-marker]:hidden">
                    <span class="group-open:hidden">Read full description</span>
                    <span class="hidden group-open:inline">Show less</span>
                    <ng-icon name="phosphorCaretDown" size="14" class="transition-transform group-open:rotate-180" aria-hidden="true" />
                  </summary>
                  <div class="mt-4 space-y-4">
                    @for (paragraph of solution.description.slice(1); track $index) {
                      <p>{{ paragraph }}</p>
                    }
                  </div>
                </details>
              }
            </div>

            <dl class="mt-10 grid grid-cols-1 gap-x-10 border-t border-cp-line sm:grid-cols-2">
              @for (feature of solution.keyFeatures; track feature.title) {
                <div class="border-b border-cp-line py-5">
                  <dt [class]="h3 + ' text-[15px]'">{{ feature.title }}</dt>
                  <dd [class]="body + ' mt-1.5'">{{ feature.content }}</dd>
                </div>
              }
            </dl>

            <div class="mt-8 flex flex-col gap-5 sm:flex-row sm:items-center sm:justify-between">
              <button type="button" (click)="onRequestTerms()" [class]="btnPrimary">Request Terms</button>
              @if (solution.disclaimer) {
                <p class="max-w-[46ch] text-[12px] leading-relaxed text-cp-subtle">{{ solution.disclaimer }}</p>
              }
            </div>
          </article>
        }
      </div>
    </div>

    <p class="mt-14">
      <a href="/documents/white-paper" target="_blank" rel="noopener noreferrer" [class]="textLink">
        View White Paper
        <ng-icon name="phosphorArrowUpRight" size="15" aria-hidden="true" />
        <span class="sr-only">(opens in a new tab)</span>
      </a>
    </p>
  </div>
</section>
